import React, { useEffect, useState } from 'react';
import { GameEngine } from 'react-game-engine';
import Character from './entities/Character';
import { characterMovement } from './systems/characterMovement';
import Wall from './entities/Wall';
import {walls1, walls2, walls3, interactiveObjects} from './objectsInfo/walls';
import { camera, char } from './objectsInfo/char'; 
import CameraZone from './entities/CameraZone';
import { actionSystem } from './systems/actionSystem';
import InteractiveObject from './entities/InteractiveObject';

const Game = () => {

  const [worldCoordinate, setWorldCoordinate] = useState({x: window.innerWidth/2, y: window.innerHeight/2})

  const interactiveEntities = interactiveObjects.reduce((entities, wall) => {
    entities[wall.id] = {
      id: wall.id,
      position: { x: wall.position.x + worldCoordinate.x, y: wall.position.y + worldCoordinate.y },
      size: wall.size,
      image: wall.image ? wall.image : null,
      unmaterial: wall.unmaterial ? wall.unmaterial : false,
      inActiveZone: false,
      renderer: <InteractiveObject />
    };
    return entities;
  }, {});

  const wall1Entities = walls1.reduce((entities, wall) => {
    entities[wall.id] = {
      position: { x: wall.position.x + worldCoordinate.x, y: wall.position.y + worldCoordinate.y },
      size: wall.size,
      image: wall.image ? wall.image : null,
      unmaterial: wall.unmaterial ? wall.unmaterial : false,
      renderer: <Wall />
    };
    return entities;
  }, {});

  const wall2Entities = walls2.reduce((entities, wall) => {
    entities[wall.id] = {
      position: { x: wall.position.x + worldCoordinate.x, y: wall.position.y + worldCoordinate.y },
      size: wall.size,
      image: wall.image ? wall.image : null,
      unmaterial: wall.unmaterial ? wall.unmaterial : false,
      renderer: <Wall />
    };
    return entities;
  }, {});

  const wall3Entities = walls3.reduce((entities, wall) => {
    entities[wall.id] = {
      position: { x: wall.position.x + worldCoordinate.x, y: wall.position.y + worldCoordinate.y },
      size: wall.size,
      image: wall.image ? wall.image : null,
      unmaterial: wall.unmaterial ? wall.unmaterial : false,
      renderer: <Wall />
    };
    return entities;
  }, {});


  return (
    <div 
      style={{
        position: 'absolute',
        height: `${window.innerHeight}px`,
        width: '100%',
        overflow: 'hidden',
        backgroundColor: 'black'
      }}>
      <GameEngine
        className='game-window'
        systems={[characterMovement, actionSystem]}
        entities={{
          character: {
            position: {
              x: worldCoordinate.x - char.size.width / 2,
              y: worldCoordinate.y - char.size.height / 2
            },
            size: {
              width: char.size.width,
              height: char.size.height
            },
            img: char.img,
            zIndex: char.zIndex,
            renderer: <Character />
          },

          //позиция камеры
          cameraZone:{ 
            size: { 
              length: camera.length
            },
            worldCenter: { 
              x: worldCoordinate.x, 
              y: worldCoordinate.y 
            },
            renderer: <CameraZone/>
          },

          //инвентарь
          inventory: {
            countSlots: 6,
            currentItem: 0,
            items: []
          },

          //стены и объекты
          ...wall1Entities,
          ...wall2Entities,
          ...wall3Entities,
          ...interactiveEntities
        }}
      >
      </GameEngine>
    </div>
  );
};

export default Game;
